import * as React from 'react';

import * as styles from './FieldRow.css';
import { UIHeading2 } from '@cian/ui-kit';

interface IFieldRowProps {
  title: string;
  field: React.ReactNode;
  dataTestId?: string;
}

export const FieldRow: React.FC<IFieldRowProps> = ({ title, field, dataTestId }) => {
  return (
    <div className={styles['field-row']} data-testid={dataTestId}>
      <UIHeading2>{title}</UIHeading2>
      <div className={styles['field']}>{field}</div>
    </div>
  );
};
